jQuery(document).ready(function ($) {
    $('.block--lux-faqs .title').click(function() {
       $(this).toggleClass('active');
    });
    $('.block--lux-faqs .faq-question').click(function () {
        const $all = $(this).closest('.faqs').find('.faq'),
            $parent = $(this).closest('.faq'),
            isOpen = $(this).hasClass('active');

        $parent.toggleClass('active');

        if(!isOpen)
            $all.not($parent).removeClass('active');
    });
});
